import { useQuery } from '@tanstack/react-query';
import { getCampaign } from '../Cadastro/services';

export const useGetCampaign = (id: string | number) => {
  return useQuery({
    queryKey: ['campaign', id],
    queryFn: () => getCampaign(id).then(res => res.data),
    enabled: !!id,
  });
};
